import { render, staticRenderFns } from "./MyAccreditationUsers.vue?vue&type=template&id=0d96f55e&scoped=true"
import script from "./MyAccreditationUsers.vue?vue&type=script&lang=js"
export * from "./MyAccreditationUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d96f55e",
  null
  
)

export default component.exports